import React from "react";
import ConfirmationModal from "../../../../components/ui/ConfirmationModal";

interface SendAttachmentsConfirmationModalProps {
	isOpen: boolean
	isLoading: boolean
	title: string
	message: string
	confirmButton: string
	processingButton: string
	onConfirm: () => void
	onClose: () => void
}

export function SendAttachmentsConfirmationModal(props: SendAttachmentsConfirmationModalProps) {
	return (
		<ConfirmationModal
			isOpen={props.isOpen}
			isLoading={props.isLoading}
			title={props.title}
			text={props.message}
			confirmationButtonLabel={props.isLoading ? props.processingButton : props.confirmButton}
			onConfirm={props.onConfirm}
			onClose={props.onClose}
		/>
	);
}
